import { VehicleReturnService } from "@App/apis/graphql/vehicleReturn/v1/VehicleReturnService";
import {
  setContractDetails,
  setIsAuthenticated,
  setPickUpAddress,
} from "@App/state/reducers/vehicleReturn";
import type { ContractDetails } from "@App/types";
import { useState } from "react";
import { useDispatch } from "react-redux";

export function useReturnIdentity(onSubmit: () => void, organizationId: number) {
  const [agreementNumber, setAgreementNumber] = useState("");
  const [numberplate, setNumberplate] = useState<string | null>(null);
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const service = new VehicleReturnService();

  function handleSubmit(data: ContractDetails, onSubmit: () => void) {
    dispatch(setContractDetails(data));
    dispatch(
      setPickUpAddress({
        name: data?.name,
        street: data?.street,
        postcode: data?.postcode,
        city: data?.city,
        phone: data?.phone,
        email: data?.email ?? null,
      }),
    );
    dispatch(setIsAuthenticated(true));
    onSubmit();
  }

  async function onClick() {
    setLoading(true);
    setError(false);
    try {
      const res = await service.getContractDetailsPickUp({
        organizationId,
        payload: {
          numberPlate: numberplate,
          agreementNumber: agreementNumber,
        },
      });
      if (!res.ok) {
        setError(true);
        return;
      }
      handleSubmit(res.data, onSubmit);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }

  const buttonDisabled = !agreementNumber || !numberplate || loading;

  return {
    onClick,
    error,
    loading,
    buttonDisabled,
    setAgreementNumber,
    setNumberplate,
  };
}
